import { render, staticRenderFns } from "./bankcutpayment.vue?vue&type=template&id=66a30b06&scoped=true&"
import script from "./bankcutpayment.vue?vue&type=script&lang=js&"
export * from "./bankcutpayment.vue?vue&type=script&lang=js&"
import style0 from "./bankcutpayment.vue?vue&type=style&index=0&id=66a30b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a30b06",
  null
  
)

export default component.exports